#!/usr/bin/env node

import { runCLI } from "./index.js";

void runCLI();
